import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const LPCTASection = ({ onOpenModal }) => (
  <section className="py-28 md:py-36 bg-[#1A3628] relative overflow-hidden" data-testid="lp-cta-section">
    {/* Subtle radial glow */}
    <div className="absolute inset-0 opacity-20" style={{ background: 'radial-gradient(ellipse at 50% 50%, #2D5A43 0%, transparent 70%)' }} />

    <div className="max-w-3xl mx-auto px-6 md:px-12 text-center relative z-10">
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-[#F9F8F6] tracking-tighter leading-tight mb-6">
        Protect your legacy.
      </h2>
      <p className="font-body text-lg text-[#F9F8F6]/50 mb-12 max-w-xl mx-auto leading-relaxed">
        Every day without protection is a day your competitors can file first. Secure your exclusive rights now.
      </p>
      <Button
        onClick={() => onOpenModal('CTA - Protect Brand')}
        className="bg-[#C85A40] hover:bg-[#A64730] text-white btn-hover py-6 px-10"
        data-testid="lp-cta-btn"
      >
        Begin Registration
      </Button>
    </div>
  </section>
);

export default LPCTASection;
